export default __webpack_public_path__ + "static/media/record.d41f64d1.png";